import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../customButton";
import DEFAULT_ROUTES from "../../constants/routes";
import RouteNotFoundBody from "./RouteNotFoundBody";
import styles from "./NotFound.module.scss";

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <Box className={styles.pageContainer}>
            <RouteNotFoundBody
                variant="page"
                description="This URL doesn't match any page in QA Path. Check the link or use one of the options below."
                actions={
                    <Box sx={{ display: "flex", gap: 1.5 }}>
                        <ButtonComponent
                            variant="primary"
                            ctaText="Sign in"
                            className="bg-blue600 white"
                            onClick={() => navigate(DEFAULT_ROUTES.LOGIN)}
                        />
                        <ButtonComponent
                            variant="outline"
                            ctaText="Back to Home"
                            onClick={() => navigate(DEFAULT_ROUTES.ROOT)}
                        />
                    </Box>
                }
            />
        </Box>
    );
};

export default NotFoundPage;
